/*
 * Copyright (c) 2020 SQUAREPING INC.
 *
 * SQUAREPING CONFIDENTIAL
 * [2019 and Beyond] SQUAREPING INC. All Rights Reserved.
 *
 * NOTICE: The source code contained herein is, and remains the property of SQUAREPING INC.
 * and its suppliers, if any. The intellectual and technical concepts contained herein are
 * proprietary to SQUAREPING INC. and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 *
 * Dissemination of this information or reproduction of this material is strictly forbidden
 * anywhere in the world unless prior written permission is obtained from SQUAREPING INC.
 */

const translations = {
  register: {
    emailExistMsg1: 'Email này đã được sử dụng cho tài khoản khác, vui lòng ',
    emailExistMsg2: '',
  },
  label: {
    numMembers: '{{num}} thành viên(s)',
    title: 'Tiêu đề',
    subTitle: 'Tiêu đề phụ',
    active: 'Hoạt động',
    inActive: 'Không hoạt động',
    supportTeam: 'Nhóm Hỗ Trợ SQUAREPING',
    businessWebsite: 'Trang web doanh nghiệp',
    selectedItems: 'Đã chọn {{num}} hàng',
    monthlyFee: 'Phí hàng tháng',
    defaultAvatar: 'Ảnh đại diện',
    businessAvatar: 'Ảnh đại diện',
    registeredAt: 'Đăng ký lúc',
    phoneNoCountryCode: 'SĐT',
    countryCode: 'Mã vùng',
    ok: 'OK',
    cancel: 'Cancel',
    login: 'Đăng nhập',
    loginID: 'ID đăng nhập',
    slogan: 'Slogan',
    branding: 'Thương hiệu doanh nghiệp',
    copyBrandingFrom: 'Sao chép thương hiệu từ đăng ký hiện có',
    selectSubscription: 'Chọn đăng ký',
    none: 'Không',
    add: 'Thêm',
    addMultiple: 'Thêm hàng loạt',
    autoRenewal: 'Tự động gia hạn',
    autoRenewalOn: 'Bật',
    autoRenewalOff: 'Tắt',
    turnOffAutoRenew: 'Tắt tự động gia hạn',
    turnOnAutoRenew: 'Bật tự động gia hạn',
    activateSubscription: 'Kích hoạt gói đăng ký',
    renewSubscription: 'Gia hạn gói đăng ký',
    cancelSubscription: 'Hủy gói đăng ký',
    pauseSubscription: 'Tạm ngừng dịch vụ',
    resumeSubscription: 'Tiếp tục dịch vụ',
    resume: 'Tiếp tục',
    cardList: 'Danh sách thẻ thanh toán',
    card: 'Thẻ',
    cardInfo: 'Thông tin thẻ',
    registerNewAccount: 'Tạo tài khoản mới',
    register: 'Đăng ký',
    createSubscription: 'Tạo gói đăng ký',
    preview: 'Xem trước',

    activate: 'Kích hoạt',
    businessInActive: 'Không hoạt động',
    businessActive: 'Hoạt động',
    deleteCard: 'Xóa thẻ',

    localLevel1: 'Tỉnh/Thành phố',
    localLevel2: 'Quận huyện',
    localLevel3: 'Phường xã',

    loadingData: 'Đang tải dữ liệu...',

    guestName: 'Tên khách',
    guest: 'Khách',
    checkIn: 'Nhận phòng',
    checkOut: 'Cài lại',
    claimed: 'Đã nhận',
    empty: 'Trống',
    clear: '',
    search: 'Tìm kiếm',
    poweredBy: 'Cung cấp bởi',
    confirmBillingCycle: 'Xác nhận chu kỳ thanh toán của bạn',
    discountCode: 'Mã giảm giá (nếu có)',
    apply: 'Áp dụng',
    startNumber: 'Số bắt đầu',
    endNumber: 'Số kết thúc',
    confirm: 'Xác nhận',
    upload: 'Tải lên',
    companyBanner: 'Ảnh bìa trên',
    companyLogo: 'Logo công ty',
    design: 'Thiết kế',
    start: 'Bắt đầu',
    end: 'Kết thúc',
    autoGenerate: 'Tự động',
    manual: 'Thủ công',
    update: 'Sửa',
    reset: 'Cài lại',
    offboarding: 'Rút người dùng',
    yes: 'Có',
    no: 'Không',
    selectThisPayment: 'Chọn thẻ này',
    addPayment: 'Thêm thẻ',
    updatePayment: 'Cập nhật thẻ',
    makeDefault: 'Đặt làm thẻ mặc định',
    delete: 'Xóa',
    profile: 'Hồ sơ',
    signOut: 'Đăng xuất',
    asLink: 'Link',
    asImage: 'Hình ảnh',
    download: 'Tải về',
    newBusiness: 'Tạo doanh nghiệp',
    address: 'Địa chỉ',
    businessEmail: 'Email doanh nghiệp',
    continue: 'Tiếp tục',
    close: 'Đóng',
    resend: 'Gửi lại',
    date: 'Ngày',
    amount: 'Số tiền',
    package: 'Gói',
    updatePassword: 'Thay đổi mật khẩu',
    currentPassword: 'Mật khẩu hiện tại',
    newPassword: 'Mật khẩu mới',
    confirmNewPassword: 'Xác nhận mật khẩu mới',
    save: 'Lưu',
    payment: 'Thanh toán',
    addExts: 'Thêm {{extensions, lowercase}}',
    addExt: 'Thêm {{extension, lowercase}}',
    addField: 'Thêm {{field, lowercase}}',
    newField: 'Thêm {{field, lowercase}}',
    updateField: 'Cập nhập {{field, lowercase}}',
    cancelField: 'Hủy {{field, lowercase}}',
    startField: 'Bắt đầu {{field, lowercase}}',
    enterField: 'Nhập {{field, lowercase}}',
    deActivateField: 'Hủy kích hoạt {{field, lowercase}}',
    deActiveBusiness: 'Tạm ngừng dịch vụ PINGPAD',
    exts: '{{extension}}',
    ext: '{{extension}}',
    extCode: 'Số {{extension}}',
    claimCode: 'Mã xác nhận',
    startExt: 'Số bắt đầu',
    endExt: 'Số kết thúc',
    passCode: 'Mã',
    digitNumber: '{{num}} chữ số',
    claimTime: 'Ngày nhận',
    claimBy: 'Nhận bởi',
    user: 'Người dùng',
    status: 'Trạng thái',
    postStatus: {
      DRAFT: 'Bản nháp',
      PUBLISHED: 'Đã xuất bản',
      EXPIRED: 'Hết hạn',
      ARCHIVED: 'Lưu trữ',
    },
    action: 'Hành động',
    extList: 'Danh sách {{extension, lowercase}}',
    subs: 'Gói đăng ký',
    businessSubs: 'Gói đăng ký',
    business: 'Doanh nghiệp',
    cardType: 'Loại thẻ',
    cardHolderName: 'Tên chủ thẻ',
    createTime: 'Ngày tạo',
    default: 'Mặc định',
    subss: 'Gói đăng ký',
    expireDate: 'Ngày hết hạn',
    cardNumber: 'Số thẻ',
    firstBillingDate: 'Ngày thanh toán đầu tiên',
    currentBillingPeriod: 'Chu kỳ thanh toán',
    nextBillingDate: 'Ngày thanh toán tiếp theo',
    nextBillingPeriodAmount: 'Số tiền thanh toán tiếp theo',
    claimTag: 'Mã Nhận {{extension}}',
    pingTag: 'Mã Gọi',
    claimServiceTag: 'Mã Dịch Vụ',
    manageExts: 'Quản lý {{extensions, lowercase}}',
    businessInfo: 'Thông tin doanh nghiệp',
    contactInfo: 'Thông tin liên lạc',
    adminContact: 'Liên hệ quản trị',
    adminContactSubtitle: 'Thông tin liên hệ và phân quyền quản lý gói đăng ký.',
    changeAdministrator: 'Đổi quản trị viên',
    adminContactDelegate: 'Quản trị viên gói đăng ký',
    adminContactHint: 'Mặc định dùng Quản trị viên tài khoản, hoặc gán email khác để quản lý gói này.',
    adminContactCurrent: 'Người đang quản lý',
    adminContactChange: 'Cập nhật email',
    adminContactAssign: 'Gán email',
    adminContactRemove: 'Đặt về mặc định',
    adminContactNone: 'Quản trị viên tài khoản (mặc định)',
    businessAddress: 'Địa chỉ doanh nghiệp',
    streetAddress: 'Địa chỉ',
    businessName: 'Tên doanh nghiệp',
    businessPhone: 'SĐT doanh nghiệp',
    phoneNumber: 'Số điện thoại',
    email: 'Email',
    country: 'Quốc gia',
    postalCode: 'Mã postal',
    newSubscription: 'Thêm\ngói đăng ký',
    newPayment: 'Thêm\nthẻ thanh toán',
    verifyEmail: 'Xác thực email',
    firstName: 'Tên',
    lastName: 'Họ',
    position: 'Chức vụ',
    positionPlaceholder: 'VD: Quản lý, Chủ sở hữu, Con chủ...',
    password: 'Mật khẩu',
    confirmPassword: 'Xác nhận mật khẩu',
    type: 'Loại',
    businessType: 'Loại hình doanh nghiệp',
    otherBusinessType: 'Chỉ định loại hình doanh nghiệp',
    otherBusinessTypePlaceholder: 'Nhập loại hình doanh nghiệp',
    name: 'Tên',
    contactInformation: 'Thông tin liên hệ',

    paymentMethod: 'Phương thức thanh toán',
    promptString: 'Câu mở đầu',
    selectPayment: 'Chọn cách thanh toán của bạn',
    verifyPayment: 'Xác nhận thẻ thanh toán',
    reviewOrder: 'Xác nhận đơn hàng',
    startYourSubs: 'Bắt đầu gói đăng ký',
    resetPassword: 'Cài lại mật khẩu',
    forgotPassword: 'Quên mật khẩu',
    signIn: 'Đăng nhập',
    yourPasscode: 'Mã của bạn',
    thisIsMyAccount: 'Đây là tài khoản của tôi',
    createNewAccount: 'Tạo tài khoản mới',
    verifySuccess: 'Xác thực thành công!\nBạn sẽ sớm nhận được thông báo qua email để đăng nhập tài khoản sau khi được duyệt\nCảm ơn bạn đã sử dụng dịch vụ của chúng tôi',
    verifyFailed: 'Xác thực không thành công!',
    tryAgain: 'Thử lại',
    startFreeTrial: 'Bắt đầu gói dùng thử 30 ngày',
    trialInfo: 'Không tính phí trong 30 ngày · Hủy bất cứ lúc nào',
    trialEndsOn: 'Hết thời gian dùng thử vào {{date}}',
    firstChargeOn: 'Lần tính phí đầu tiên vào {{date}}',
    confirmTrial: 'Bắt đầu dùng thử',
  },
  msg: {
    adminContactRemoveConfirm: 'Gỡ phân quyền quản trị gói đăng ký này?',
    pleaseFinishCaptchaVerification: 'Vui lòng hoàn thành xác thực robot',
    passwordHint: 'Sử dụng 8 ký tự trở lên và kết hợp chữ cái, chữ số và biểu tượng',
    passwordMinRule: 'Chiều dài tối thiểu của mật khẩu là 8 ký tự',
    passwordMaxRule: 'Chiều dài tối đa của mật khẩu là 16 ký tự',
    passwordSpaceRule: 'Mật khẩu không được chứa dấu cách',
    passwordDigitRule: 'Mật khẩu phải chứa ít nhất 1 ký tự là chữ số',
    passwordLowercaseRule: 'Mật khẩu phải chứa ít nhất 1 ký tự viết thường',
    passwordUppercaseRule: 'Mật khẩu phải chứa ít nhất 1 ký tự viết hoa',
    passwordSpecialRule: 'Mật khẩu phải chứa ít nhất 1 ký tự đặc biệt',
    imgNotSupported: 'Loại tệp {{type}} hiện không hỗ trợ, vui lòng chọn hình ảnh thuộc một trong những loại sau: {{types}}',
    imgSizeExceed: 'Kích thước tối đa của hình ảnh là {{size}} MB',
    searchExtHint: 'Tìm {{extension, lowercase}}',
    searchPostHint: 'Tìm bài viết',
    subsPriceUpdated: 'Phí đăng ký mỗi tháng sẽ được cập nhật thành {{price}} từ ngày gia hạn tiếp theo.',
    bannerHint: 'Kích thước đề nghị (640x300)',
    copyBrandingHint: 'Sao chép banner, logo và slogan từ đăng ký khác. Hữu ích cho các chuỗi doanh nghiệp có nhiều địa điểm.',
    brandingWillBeCopied: 'Các thành phần thương hiệu sau sẽ được sao chép:',
    autoRenewalOffWarning: 'Gói đăng ký này sẽ tự động bị hủy vào lần gia hạn tiếp theo.',
    addMultipleExtSuccess: '{{number}} {{extension, lowercase}} đã được thêm.',
    changeExtensionTypeConfirm: 'Danh sách {{extension, lowercase}} sẽ được làm trống và cài đặt lại để chuyển sang phương thức gọi mới, bạn có chắc muốn thay đổi?',
    cancelSubsConfirm: 'Dịch vụ PINGPAD sẽ bị ngừng ngay sau khi hủy. Bạn có chắc muốn hủy không?',
    pauseSubsConfirm: 'Dịch vụ PINGPAD sẽ bị ngừng ngay cho đến khi được tiếp tục lại. Bạn có chắc muốn tạm ngừng không?',
    selectPaymentCardFor: `Chọn thẻ thanh toán cho {{business}}`,
    duplicateExtension: '{{extension}} đã tồn tại, vui lòng nhập {{extension, lowercase}} khác.',
    input: 'Nhập {{field, lowercase}}',
    cancelAnyTime: 'Bạn có thể hủy bất cứ lúc nào.',
    subscriptionStepsHint: 'Hoàn tất đăng ký trong 3 bước đơn giản.',
    cancelSubsWarning: 'Dịch vụ PINGPAD sẽ bị tạm ngừng sau 7 ngày từ lúc hủy đăng ký.',
    verifySuccess: 'Bạn đã xác thực email thành công!',
    verifyFailed: 'Không thể xác thực tài khoản của bạn, vui lòng thử lại hoặc liên hệ với đội hỗ trợ của chúng tôi',
    newToPING: 'Chưa sử dụng PINGPAD?',
    signUpNewAccount: 'Đăng ký tài khoản mới ở đây',
    loginTitle: 'Xin chào',
    resendSuccessful: 'Gửi lại thành công!',
    resetPassHint: 'Để cài lại mật khẩu, vui lòng nhập email đã đăng ký',
    pleaseConfirmNewPass: 'Vui lòng xác nhận mật khẩu mới',
    pleaseConfirmPass: 'Vui lòng xác nhận mật khẩu',
    pleaseSelectPayment: 'Vui lòng chọn 1 cách thanh toán',
    endExtMustLarger: 'Số kết thúc phải lớn hơn số bắt đầu',
    createSuccess: 'Tạo {{field, lowercase, autoSpace}}thành công!',
    updateSuccess: 'Cập nhật {{field, lowercase, autoSpace}}thành công!',
    removeSuccess: 'Xóa {{field, lowercase, autoSpace}}thành công!',
    cancelSuccess: 'Hủy {{field, lowercase, autoSpace}}thành công!',
    addSuccess: 'Thêm {{field, lowercase}} thành công!',
    startSuccess: 'Tạo {{field, lowercase}} thành công!',
    deActiveSuccess: 'Hủy kích hoạt {{field, lowercase}} thành công!',
    resetSuccess: 'Cài lại {{field, lowercase}} thành công!',
    pleaseSelect: 'Vui lòng chọn {{field}}',
    pleaseInput: 'Vui lòng nhập {{field, lowercase}}',
    emailAlreadyExists: 'Email này đã được đăng ký. Người dùng sẽ được liên kết với extension này.',
    fieldInvalid: 'Vui lòng nhập {{field, lowercase}} hợp lệ',
    numberInvalid: '{{field}} phải là chữ số hợp lệ',
    maxLengthInvalid: 'Chiều dài tối đa của {{field, lowercase}} là {{max}}',
    lengthInvalid: 'Chiều dài của {{field, lowercase}} là {{max}}',

    resetExtConfirm: 'Bạn có chắc muốn cài lại {{extension}} này?',
    offboardingExtConfirm: 'Bạn có chắc muốn rút người dùng khỏi {{extension}} này? Dữ liệu người dùng sẽ bị xóa.',
    removeConfirm: 'Bạn có chắc muốn xóa {{field, lowercase}} này?',
    unClaimConfirm: 'Bạn có chắc muốn xóa người nhận trong {{field, lowercase}} này?',
    cancelConfirm: 'Bạn có chắc muốn hủy {{field, lowercase}} này?',
    invalidExtCode: '{{extension}} chỉ bao gồm số và chữ cái',
    extensionRangeMaxLength: 'Tối đa 6 ký tự chữ và số, kết thúc bằng chữ số thập phân',
    extensionRangeEndWithDigits: 'Số bắt đầu và kết thúc phải kết thúc bằng chữ số thập phân.',

    autoGenerateClaimCode: 'Tự động tạo mã xác nhận với 4 chữ số.',

    requireClaimCodeForExt: 'Yêu cầu mã xác nhận',

    cannotLoadData: 'Không thể tải dữ liệu',
    cannotLoadPaymentMethod: 'Không thể tải thông tin thanh toán',

    unclaimSuccess: 'Nhận thẻ thành công',

    cancelBusinessSubsConfirm: 'Bạn có chắc muốn hủy gói đăng ký và tạm ngừng dịch vụ PINGPAD cho doanh nghiệp này?',
    cancelBusinessConfirm: 'Bạn có chắc muốn tạm ngừng doanh nghiệp?',

    extensionQuotaExceeded: 'Đã đạt giới hạn extension ({{current}}/{{max}}). Vui lòng nâng cấp gói.',
    errorTryAgain: 'Có lỗi xảy ra, vui lòng thử lại!',
    confirmDontMatch: 'Mật khẩu và xác nhận không trùng',
    pleaseVerifyEmail: 'Bạn sẽ nhận được thông báo qua email này khi tài khoản đăng ký được kích hoạt. Vui lòng kiểm tra hòm thư để xác thực email.',
    pleaseChooseCountry: 'Vui lòng chọn quốc gia',
    streetPlaceHolder: 'Số nhà, tên đường...',
    cancelSubsBeforeDeletePayment: 'Vui lòng hủy tất cả gói đăng ký được liên kết với thẻ này trước khi xóa nó',
    invalidDiscount: 'Mã giảm giá không đúng',
    discountApplySuccess: 'Áp dụng mã thành công!',
    cannotApplyDiscount: 'Không thể áp mã giảm giá, vui lòng thử lại',
    cardVerifyFail: 'Không thể xác nhận thẻ, vui lòng kiểm tra thông tin thẻ',
    reviewOrder1a: 'Sau khi gói đăng ký được bắt đầu,',
    reviewOrder1b: ' thẻ của bạn sẽ thanh toán số tiền ${{price}} (cộng thêm thuế)',
    reviewOrder2a: 'Gói đăng ký sẽ được tự động gia hạn mỗi tháng đến khi bị hủy.',
    reviewOrder2b: ' Để tránh tự động thanh toán trong tháng tiếp theo, vui lòng tắt chế độ gia hạn tự động hoặc hủy trước ngày gia hạn.',
    reviewOrder3a: 'Bằng việc chấp nhận thanh toán này bạn đồng ý với ',
    reviewOrder3b: 'điều khoản dịch vụ',
    reviewOrder3c: '. Để đảm bảo dịch vụ trong tương lai, chúng tôi sẽ lưu và cập nhập ( ví dụ: mỗi lần gia hạn ) thông tin thanh toán của bạn. Giá có thể thay đổi.',

    emailNotConfirm: 'Email của bạn chưa được xác thực',
    verifyEmailHint: 'Vui lòng kiểm tra hộp thư đến ( hoặc mục spam ), mở email xác thực từ SQUAREPING và nhấn vào đường link trong email để hoàn tất đăng ký.',
    resendVerifyEmailHint: 'Không nhận được email? Gửi lại email xác thực',
    resendVerifyEmailSuccess: 'Đã gửi lại email xác thực. Vui lòng kiểm tra hộp thư.',

    accountNotApproved: 'Tài khoản của bạn chưa được duyệt',
    approveHint: 'Tài khoản của bạn đang trong quá trình kiểm duyệt. Mọi thông tin cập nhật sẽ được gửi đến email đã đăng ký của bạn.',

    blockHint1: 'Tài khoản của bạn đã bị tạm ngừng. Vui lòng liên hệ  ',
    blockHint2: '  để giải quyết.',

    resendPasscodeHint: 'Không nhận được mã xác thực ? gủi lại ngay',
    areYou: 'Bạn có ',
    inputEmailToContinue: 'Nhập email của bạn để tiếp tục',
    createAccountHint: 'Không thể nhớ email của bạn ? tạo tài khoản mới',
    invalidResetPassLink: 'Link cài lại mật khẩu không đúng!',
    resetPassSuccess: 'Sủa mật khẩu thành công',
    resetYourAccount: 'Cài lại tài khoản',

    qrLinkSaved: 'Mã QR đã được sao chép',
  },
  serviceTag: {
    changePasscode: 'Sửa mã xác nhận',
    service: 'Dịch vụ',
    activate: 'Kích hoạt',
    deActivate: 'Ngừng dịch vụ',
    manage: 'Quản lý thẻ dịch vụ',
    unClaim: 'Cài lại',
    unClaimConfirm: 'Bạn có chắc muốn cài lại thẻ dịch vụ này?',
    claimQR: 'Mã QR nhận thẻ',
    noEmployee: 'Chưa được nhận',
    type: {
      Operator: 'Điều phối',
      Lobby: 'Sảnh đợi',
      Security: 'An ninh',
      Parking: 'Đỗ xe',
      WIFI: 'WIFI',
      RoomService: 'Làm phòng',
      Massage: 'Mát xa',
      FoodDrink: 'Ăn uống',
      Restaurant: 'Nhà hàng',
      ConvenientStore: 'Cửa hàng tiện lợi',
      FitnessCenter: 'Trung tâm thể hình',
      SwimmingPool: 'Hồ bơi',
      Spa: 'Spa',
      Office: 'Văn phòng',
      Maintenance: 'Bảo trì',
      Laundry: 'Giặt ủi',
      Custom: 'Tùy chỉnh',
    },
  },
  braintree: {
    payWithCard: 'Sử dụng thẻ',
    chooseAnotherWayToPay: 'Chọn cách thanh toán khác',
    chooseAWayToPay: 'Chọn cách thanh toán',
    otherWaysToPay: 'Chọn cách thanh toán khác',

    //form
    cardholderNameLabel: 'Tên chủ thẻ',
    cardNumberLabel: 'Số thẻ',
    cvvLabel: 'CVV',
    cvvThreeDigitLabelSubheading: '(3 số)',
    cvvFourDigitLabelSubheading: '(4 số)',
    expirationDateLabel: 'Ngày đáo hạn',
    expirationDateLabelSubheading: '(TT/NN)',
    cardholderNamePlaceholder: '',
    expirationDatePlaceholder: 'TT/NN',
    postalCodeLabel: 'Mã Postal',
    saveCardLabel: 'Lưu thẻ',

    //error
    fieldEmptyForCvv: 'Vui lòng nhập CVV.',
    fieldEmptyForExpirationDate: 'Vui lòng nhập ngày hết hạn.',
    fieldEmptyForCardholderName: 'Vui lòng nhập tên chủ thẻ.',
    fieldEmptyForNumber: 'Vui lòng nhập số thẻ.',
    fieldEmptyForPostalCode: 'Vui lòng nhập mã postal.',
    fieldInvalidForCardholderName: 'Tên chủ thẻ không hợp lệ.',
    fieldInvalidForCvv: 'Mã bảo vệ không hợp lệ.',
    fieldInvalidForExpirationDate: 'Ngày hết hạn không hợp lệ.',
    fieldInvalidForNumber: 'Số thẻ không hợp lệ.',
    fieldInvalidForPostalCode: 'Mã postal không hợp lệ.',
    fieldTooLongForCardholderName: 'Tên chủ thẻ không được vượt quá 256 ký tự',
    genericError: 'Xảy ra lỗi trên hệ thống của chúng tôi.',
    hostedFieldsTokenizationFailOnDuplicateError: 'Thẻ này đã tồn tại.',
    hostedFieldsFailedTokenizationError: 'Vui lòng kiểm tra lại thông tin và thử lại.',
    hostedFieldsTokenizationCvvVerificationFailedError: 'Không thể xác thực thẻ. Vui lòng kiểm tra lại thông tin và thử lại.',
    hostedFieldsTokenizationNetworkErrorError: 'Lỗi mạng. Vui lòng thử lại.',
    hostedFieldsFieldsInvalidError: 'Vui lòng kiểm tra lại thông tin và thử lại.',
    paypalButtonMustBeUsed: 'Sử dụng nút Paypal để tiếp tục với thanh toán của bạn.',
    paypalAccountTokenizationFailedError: 'Xảy ra lỗi khi thêm tài khoản Paypal. Vui lòng thử lại.',
    paypalFlowFailedError: 'Xảy ra lỗi khi kết nối tới Paypal. Vui lòng thử lại.',
    paypalTokenizationRequestActiveError: 'Quá trình xác thực Paypal đã được bắt đầu.',
    vaultManagerPaymentMethodDeletionError: 'Không thể xóa thẻ. Vui lòng thử lại.',
    unsupportedCardTypeError: 'Loại thẻ này không được hỗ trợ. Vui lòng sử dụng thẻ khác.',
  },
  extension: {
    changePasscode: 'Sửa mã nhận',
    managementMethod: 'Loại cuộc gọi',
    typeFlex: 'Internet hoặc di động',
    typePhone: 'Di động',
    flexHint: '{{extension}} có thể được cài đặt để gọi internet hoặc di dộng.',
    phoneHint: '{{extension}} chỉ dùng cho việc gọi di động.',
    premiumHint: 'Hỗ trợ nhiều cuộc gọi cùng lúc trên nhiều thiết bị cho mỗi {{extension, lowercase}}.',
    extensionHint: 'Tối đa 6 ký tự bao gồm số và chữ cái.',
    extensionRangeHint:
      'Phần mở rộng tối đa 6 ký tự chữ và số. Với dải số, phần mở rộng đầu và cuối phải kết thúc bằng số. Cả hai có thể có tiền tố là chữ cái, ví dụ: ABC100 - ABC650',
    claimCodeHint1: 'Yêu cầu người dùng nhập mã xác nhận khi nhận {{extension, lowercase}}.',
    autoGenerateClaimCode: 'Mã xác nhận gồm 4 số sẽ được tạo tự động cho mỗi {{extension, lowercase}}.',

    removeManyConfirm: 'Bạn có chắc muốn xóa những {{extensions, lowercase}} đã chọn?',
    removeManySuccess: 'Xóa thành công!',

    tableTotal: 'Tổng: {{total}}',
    tableTotalVsActive: 'Tổng: {{total}} · Đã kích hoạt: {{active}}',
    summaryTotal: 'Tổng',
    summaryActive: 'Đã kích hoạt',
    requireClaimCodeConfirm: 'Mã xác nhận là bắt buộc để nhận extension',
    notRequireClaimCodeConfirm: 'Mã xác nhận không bắt buộc để nhận extension',

    clearManyConfirm: 'Bạn có chắc muốn làm trống những {{extensions, lowercase}} đã chọn?',
    offboardingExtConfirm: 'Bạn có chắc muốn rút người dùng khỏi {{extension}} này? Dữ liệu người dùng sẽ bị xóa.',
    offboardingManyConfirm: 'Bạn có chắc muốn rút người dùng khỏi những {{extensions, lowercase}} đã chọn? Dữ liệu người dùng sẽ bị xóa.',
    clearManySuccess: 'Làm trống thành công!',

    checkInSuccess: 'Nhận phòng thành công!',
    addGuestTitle: 'Thêm khách',
    onboardingTitle: 'Thêm người dùng',
    onboardingSuccess: 'Đã thêm người dùng thành công.',
    userProfileTitle: 'Hồ sơ người dùng',
    unClaimAction: 'Làm trống',
    unClaimConfirm: 'Bạn có chắc muốn làm trống {{extension, lowercase}} này?',

    unit: {
      extension: 'Số mở rộng',
      room: 'Phòng',
      unit: 'Đơn vị',

      extensionFull: 'Số mở rộng',
      roomFull: 'Phòng',
      unitFull: 'Đơn vị',

      extensionFullPlural: 'Số mở rộng',
      roomFullPlural: 'Phòng',
      unitFullPlural: 'Đơn vị',

      extensionPlural: 'Số mở rộng',
      roomPlural: 'Phòng',
      unitPlural: 'Đơn vị',
    },
  },
  subscription: {
    discount: 'Mã giảm giá',
    total: 'Tổng hóa đơn',
    monthlyTotal: 'Tổng tiền hàng tháng',
    subTotal: 'Tổng phí dịch vụ',
    freeTrialCode: '30 ngày dùng thử miễn phí',
    startTrialCta: 'Dùng thử miễn phí 30 ngày',
    missingPaymentForTrial: 'Vui lòng thêm phương thức thanh toán để bắt đầu dùng thử miễn phí.',
    trialStartedSuccess: 'Bạn đã bắt đầu gói dùng thử miễn phí 30 ngày.',
    renewSubscription: 'Gia hạn gói đăng ký',
    renewedSuccess: 'Bạn đã gia hạn gói đăng ký thành công.',
    subscribeCta: 'Đăng ký',
    promoAndDiscountCode: 'Mã khuyến mãi và giảm giá',
    promoAndDiscountCodePlaceholder: 'Nhập mã khuyến mãi và giảm giá',
    trialCodeHint: '',
    subscribeDisclaimer: 'Bạn sẽ không bị tính phí cho đến khi xác nhận.',
    trialBillingDisclaimer: 'Ưu đãi dùng thử chỉ được áp dụng khi mã hợp lệ.',
    nextChargeLabel: 'Lần tính phí tiếp theo:',
    endsOnLabel: 'Gói đăng ký kết thúc:',
    cancellationAlreadyScheduled: 'Đã lên lịch hủy gói đăng ký',
    reactivateSubscription: 'Kích hoạt lại gói đăng ký',
    reactivationSuccess: 'Gói đăng ký đã được kích hoạt lại thành công.',
    updateRequiresChanges: 'Thay đổi gói hoặc số lượng extension để cập nhật',
    noPlanChangesDetected: 'Hãy thay đổi gói hoặc số lượng extension trước khi cập nhật.',
    trialDaysRemainingOne: 'Còn 1 ngày dùng thử',
    trialDaysRemainingOther: 'Còn {{count}} ngày dùng thử',
    extensionCount: 'Số lượng {{extensions, lowercase}}',
    extensionPrice: 'Phí đăng ký từng tháng cho mỗi {{extensions, lowercase}}',
    basePrice: 'Giá gói đăng ký',
  },
  payment: {
    transferSubsTo: 'Liên kết gói đăng ký với',
  },
  business: {
    serviceOptions: 'Dịch vụ',
    serviceLevel: 'Gói',
    serviceLevelPremium: 'Cao cấp',
    serviceLevelStandard: 'Cơ bản',

    lodging: 'Khách sạn',
    residential: 'Khu dân cư',
    office: 'Công ty/cơ quan',
    publicHousing: 'Nhà ở công cộng',
    nonProfitOrganization: 'Tổ chức phi lợi nhuận',
    remoteMobileStaff: 'Nhân viên từ xa/Di động',
    other: 'Khác',

    lodgingHint: 'Khách sạn, nhà nghỉ...',
    residentialHint: 'Chung cư các loại.',
    officeHint: 'Trụ sở công ty/cơ quan các loại.',
    publicHousingHint: 'Cơ quan quản lý nhà ở công cộng, đơn vị phát triển nhà ở xã hội và tổ chức liên quan.',
    nonProfitOrganizationHint: 'Các tổ chức phi lợi nhuận và tổ chức từ thiện đã đăng ký.',
    remoteMobileStaffHint: 'Hoạt động nhân viên từ xa hoặc di động.',

    setting: {
      requirePasscodeOption: 'Yêu cầu mã xác nhận để nhận {{extension, lowercase}}',
    },
  },
  design: {
    // pingTitle: 'Call screen for guest',
    // claimTitle: 'Claim extension screen for guest',
    // pingLabel: 'Design call screen',
    // claimLabel: 'Design claim screen',
    label: 'Trang thiết kế',
    settings: 'Cài đặt',
    callPreview: 'Trang gọi đến',
    claimPreview: 'Trang nhận {{extension, lowercase}}',
    incomingPreview: 'Trang nhận cuộc gọi',

    //callHint: 'Caller will see this screen when placing a call via the PING tag.',
    callHint: 'Khách gọi tới sẽ dùng giao diện này khi quét MÃ GỌI để thực hiện cuộc gọi.',
    claimHint: 'Người dùng hệ thống sẽ dùng giao diện này sau khi quét MÃ NHẬN để nhân {{extension, lowercase}}',

    sloganHint: 'Slogan cho doanh nghiệp',
    sloganDefault: 'Slogan doanh nghiệp',

    callPromptString: 'Câu giới thiệu cho khách gọi đến',
    callPromptStringDefault: 'Nhập số phòng để gọi',
    callPromptStringHint: '',

    claimPromptString: 'Câu giới thiệu cho khách nhận phòng',
    claimPromptStringDefault: 'Nhập số phòng để nhận',
    claimPromptStringHint: '',

    extensionUnitSetting: 'Cài đặt tên đơn vị',
  },
  about: {
    title: 'Thông Tin',
    version: 'Phiên bản',
    build: 'Số phiên bản',
    buildDate: 'Ngày phát hành',
    feedback: 'Gửi phản hồi',
    terms: 'Điểu khoản sử dụng',
    policy: 'Chính sách bảo mật',
    disclaimer: 'Từ chối trách nhiệm',
    parentalConsentForm: 'Mẫu chấp thuận của phụ huynh',
    feedbackSubject: 'Góp ý',
    feedbackBody:
      'Xin hãy cho biết ý kiến của bạn:\n' +
      '\n' +
      '\n' +
      '\n' +
      '\n' +
      '---------------\n' +
      'Thông tin ứng dụng!\n' +
      'Model: {{model}}\n' +
      'OS Version: {{osVersion}}\n' +
      'App Version: {{appVersion}}\n' +
      'UID: {{uid}}',
  },
  adminAccounts: {
    title: 'Tài khoản PINGPAD',
    suspenseConfirm: 'Bạn có chắc muốn tạm ngừng dịch vụ PINGPAD cho tài khoản này?',
    approveConfirm: 'Bạn có chắc muốn kích hoạt tài khoản này?',
    approve: 'Kích hoạt',
    suspenseTitle: 'Tạm ngừng dịch vụ',
    suspenseReason: 'Lý do tạm ngừng',
    suspense: 'Tạm ngừng',
    resume: 'Kích hoạt',
    viewSubs: 'Xem gói đăng ký',
    activeSubscription: 'Gói đăng ký hoạt động',
    totalExtensions: 'Số lượng {{extensions, lowercase}}',
    activeExtensions: '{{extensions}} đã kích hoạt',
    deleteTitle: 'Đánh dấu tài khoản đã xóa',
    deleteConfirm: 'Bạn có chắc muốn đánh dấu tài khoản này là đã xóa? (xóa mềm)',
    deleteReason: 'Lý do xóa (tùy chọn)',
    delete: 'Xóa',
  },
  adminSubscription: {
    title: 'Gói đăng ký',
    servicePlan: 'Gói dịch vụ',
    quota: 'Hạn mức',
    quotaTitle: 'Hạn mức gói đăng ký',
    quotaHint: 'Đặt giới hạn tài nguyên cho gói đăng ký này. Admin có thể ghi đè mặc định theo gói.',
    currentUsage: 'Đang sử dụng',
    extensionsUsage: 'Extensions: {{current}} / {{limit}}',
    maxExtensions: 'Tối đa extensions',
    quotaSaved: 'Đã cập nhật hạn mức thành công',
    resetToDefaults: 'Khôi phục mặc định',
    downgradeBlockedTitle: 'Chưa thể downgrade',
    downgradeBlockedIntro: 'Vui lòng giảm các tài nguyên sau trước khi downgrade xuống {{plan}}:',
    downgradeBlockerMessage: 'Bạn đang có {{current}} {{resource}}. Gói mới cho phép tối đa {{max}}. Vui lòng xóa bớt {{toRemove}} trước khi downgrade.',
    downgradeGoTo: 'Đi tới {{resource}}',
    servicePlanFeaturesTitle: 'Tính năng gồm có',
    servicePlanFeaturesIntro: 'Chi tiết năng lực trong gói Standard và các gói cao hơn.',
    servicePlanPricingTitle: 'Giá extension & add-on',
    servicePlanPricingIntro: 'Bậc extension theo tháng và add-on tùy chọn. Gói cơ bản tính phí riêng.',
    extensionsPricingLabel: 'Extensions',
    addonsPricingLabel: 'Add-ons',
    addonUnitBoard: 'bảng',
    addonUnitUnit: 'thiết bị',
  },
  sidebar: {
    groupBusiness: 'Doanh nghiệp',
    groupCommunication: 'Dịch vụ gọi',
    groupAccessControl: 'Kiểm soát ra vào',
    groupVisitors: 'Khách',
    businessProfile: 'Hồ sơ doanh nghiệp',
    servicePlans: 'Gói dịch vụ',
    branding: 'Thương hiệu',
    roles: 'Phân quyền',
    policies: 'Chính sách',
    extensions: 'Số mở rộng',
    bulletinBoard: 'Trung tâm liên lạc',
    callAuditLog: 'Nhật ký cuộc gọi',
    visitorManagement: 'Quản lý khách',
    entranceManagement: 'Quản lý lối vào',
    doorManagement: 'Quản lý cửa',
    services: 'Dịch vụ',
  },
};

export default translations;
